/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import I18n from 'I18n';
import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import partial from 'transmute/partial';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useUserInfo from '../../../access/useUserInfo';
import { getUserId } from '../../../data/schemas/userInfoSchema';
import { useMutation } from 'data-fetching-client';
import { EDIT_ASSET_SCHEDULE } from 'dashboard-lib/public/emails/emails';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const assetSpecificTrackingPropsPropDefault = {};
const ChangeRecurringAssetOwnerModal = ({
  appUsageTracker,
  closeDialog,
  schedule,
  createAndOwnUsersLabels,
  onEditSuccess = noop,
  objectType,
  assetSpecificTrackingProps = assetSpecificTrackingPropsPropDefault,
  currentDialog
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const [editAssetScheduleMutation] = useMutation(EDIT_ASSET_SCHEDULE);
  const {
    data: userInfo
  } = useUserInfo();
  const ownerId = String(schedule.ownerId);
  const currentUserId = String(getUserId(userInfo));
  const [selectedId, setSelectedId] = useState(ownerId);
  const ownerIsSelected = selectedId === ownerId;
  const displayedValue = createAndOwnUsersLabels.findIndex(({
    value
  }) => value === selectedId) >= 0 ? selectedId : null;
  const handleChange = ({
    target: {
      value
    }
  }) => {
    setSelectedId(value);
  };
  const handleSave = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.updateSavedRecurringShareAsset, Object.assign({
        object: currentDialog,
        actionType: 'save',
        action: 'change-owner',
        interactionSource: 'dialog',
        assetType: objectType.toLowerCase()
      }, assetSpecificTrackingProps));
    }
    const updatedSchedule = Object.assign({}, schedule, {
      ownerId: selectedId
    });
    editAssetScheduleMutation({
      variables: Object.assign({
        scheduledEmailId: updatedSchedule.id
      }, updatedSchedule)
    }).then(() => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.alert.success",
          options: {
            emailName: schedule.nickname || schedule.subject
          }
        }),
        type: 'success'
      });
      onEditSuccess();
      closeDialog();
    }, () => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.alert.failure"
        }),
        type: 'danger'
      });
      closeDialog();
    });
  };
  const AssignToMeButton = /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: partial(handleChange, SyntheticEvent(String(currentUserId))),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.action.assignToMe"
    })
  });
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.header"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(Form, {
        onSubmit: handleSave,
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.owner",
            options: {
              dialog: currentDialog
            }
          }),
          children: /*#__PURE__*/_jsx(Select, {
            onChange: handleChange,
            options: createAndOwnUsersLabels,
            value: displayedValue,
            dropdownFooter: AssignToMeButton,
            placeholder: I18n.text('reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.placeholder')
          })
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        disabled: !ownerIsSelected,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.alreadyOwner"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: handleSave,
          disabled: ownerIsSelected,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.action.confirm"
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: closeDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.action.cancel"
        })
      })]
    })]
  });
};
export default ChangeRecurringAssetOwnerModal;
ChangeRecurringAssetOwnerModal.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  closeDialog: PropTypes.func.isRequired,
  schedule: PropTypes.object.isRequired,
  createAndOwnUsersLabels: PropTypes.array.isRequired,
  onEditSuccess: PropTypes.func,
  objectType: PropTypes.string.isRequired,
  assetSpecificTrackingProps: PropTypes.object,
  currentDialog: PropTypes.string
};